import React from 'react';

import PropTypes from 'prop-types';

import { Flex } from '@adsk/alloy-react-box';
import ProgressRing from '@adsk/alloy-react-progress-ring';

const ReferencePickerLoader = ({ style, className }) => {
  return (
    <Flex
      justifyContent="center"
      padding="24px"
      className={className}
      style={style}
    >
      <ProgressRing size={ProgressRing.SIZES.SMALL} />
    </Flex>
  );
};

ReferencePickerLoader.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default ReferencePickerLoader;
